import { Banner } from '@stenajs-webui/elements';

export const NoSailingSelected = () => (
  <Banner text={'Please select a departure time'} variant={'warning'} />
);
